import React, { useEffect, useState } from "react";
import { Button, Container, Nav, Navbar } from "react-bootstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import styles from "./Header.module.scss";
import logo from "../../Assets/images/logo.png";
import ConfirmationPop from "../Modals/ConfirmationPop";
import { useDispatch, useSelector } from "react-redux";
import { ProfileView } from "../../store/profile/actions";
import BackButtom from "../BackButton";
const Header = ({ sidebar, setSidebar }) => {
  const { user, authToken } = useSelector((state) => state.Auth);
  const [adminProfile, setAdminProfile] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [confirmation, setConfirmation] = useState();
  const pageName = location.pathname;
  const { id } = useParams();
  let lastSlashIndex = pageName.lastIndexOf("/");
  let heading;
  if (lastSlashIndex !== -1) {
    const afterLastSlash = pageName.substring(lastSlashIndex + 1);
    heading = afterLastSlash;
  }
  const handleSidebar = () => {
    setSidebar(!sidebar);
  };

  const handleConfirmation = () => setConfirmation(!confirmation);

  const fetchData = async () => {
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          console.log(res);
          setAdminProfile(res);
          toast.success(res.data.message);
        }
      };
      // dispatch(ProfileView({ callback }));
    } catch (error) {
      console.error(error, "<===err");
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <ConfirmationPop
        confirmation={confirmation}
        setConfirmation={setConfirmation}
      />
      <header
        className={`${styles.siteHeader}  siteHeader bg-white  sticky-top pt-lg-3 py-1 w-100 border-bottom`}
        style={{ zIndex: 99 }}
      >
        <Container>
          <Navbar expand="lg" className="flex-nowrap justify-content-between">
            <div className="d-flex align-items-center flex-shrink-0 ">
              <Button
                onClick={handleSidebar}
                className="d-lg-none border-0 p-0"
                variant="transparent"
                style={{ width: 30 }}
              >
                {menuIcn}
              </Button>
              <Navbar.Brand className={`${styles.logo} d-lg-none`} href="#">
                <span
                  className="themeClr d-flex justify-content-center fw-bold"
                  style={{ fontSize: 30 }}
                >
                  <img
                    src={logo}
                    style={{ height: 55 }}
                    alt=""
                    className="img-fluid"
                  />
                </span>
              </Navbar.Brand>
            </div>
            {/* <Navbar.Toggle
              className="border-0 p-0"
              aria-controls="navbarScroll"
            /> */}
              <Nav className=" my-2 my-lg-0 align-items-center justify-content-end gap-10 flex-wrap">
                {/* <div className="left d-flex align-items-center gap-10 flex-wrap">
                  <h5 className="m-0 fw-sbold text-capitalize d-lg-block d-none">
                    {id && (
                      <>
                        <BackButtom />
                        {"Details"}
                      </>
                    )}
                  </h5>
                </div> */}
                <div className="right d-flex align-items-center gap-10 flex-wrap">
                  <Link
                    className={`${styles.profileLink} d-flex align-items-center gap-10`}
                    to="/profile"
                  >
                    {/* <span className="flex-shrink-0">{user}</span> */}

                    <div className="content">
                      <h6 className="m-0 fw-bold text-dark">
                        {/* {adminProfile?.data?.name} */}
                        Admin User
                      </h6>
                      <p className="m-0 themeClr fw-sbold">
                        {/* {adminProfile?.data?.email} */}
                        admin@gmail.com
                      </p>
                    </div>
                  </Link>
                </div>
              </Nav>
            {/* <Navbar.Collapse
              className={` justify-content-end w-100`}
              id="navbarScroll"
            >
            </Navbar.Collapse> */}
          </Navbar>
        </Container>
      </header>
    </>
  );
};

export default Header;

const user = (
  <svg
    className=""
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_0_4298)">
      <rect width="38" height="38" rx="10" fill="#2F80ED"></rect>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.3967 25.1722C23.7081 25.1722 27.2168 21.6652 27.2168 17.3538C27.2168 13.0408 23.7081 9.53369 19.3967 9.53369C15.0852 9.53369 11.5781 13.0408 11.5781 17.3538C11.5781 21.6652 15.0852 25.1722 19.3967 25.1722Z"
        fill="white"
      ></path>
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.3032 36.7026C29.6945 31.6154 25.372 28.7005 19.4393 28.7005H19.3965C13.448 28.6672 9.10335 31.6027 7.49152 36.7026L7.30469 37.2948L7.83352 37.6178C10.9337 39.5083 14.8002 40.4662 19.3221 40.4662C19.3728 40.4662 19.4234 40.4662 19.4725 40.4662C24.0579 40.4662 27.8167 39.5336 30.9612 37.6178L31.49 37.2948L31.3032 36.7026Z"
        fill="white"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_0_4298">
        <rect width="38" height="38" fill="white"></rect>
      </clipPath>
    </defs>
  </svg>
);

const menuIcn = (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 1L1 1M15.625 7.75L1 7.75M12.25 14.5H1"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);
